<template>
  <div>
    {{ dateTime }}
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'LiveDateTime',
  data() {
    return{
      dateTime: ''
    }
  },

  created() {
    var dateTimeFormat = 'DD, MMM YYYY | H:mm A';
    this.dateTime = moment().format(dateTimeFormat);

    // check and set date time every 30 seconds
    setInterval(()=>{
      this.dateTime = moment().format(dateTimeFormat);
    }, 30000);
  }
}
</script>
